import { Outlet } from 'react-router-dom';

export default function PublicLayoutComponent() {
  return (
    <div className="public-page">
      <Outlet />
    </div>
  );
}
